<template>
    <div class="container">
        <div class="topBg">
            <mt-swipe ref="swipe" :auto="0" @change="handleChange" :show-indicators="false" >
                <mt-swipe-item v-for="(item,index) in biaoList" :key="index">
                    <div class="swiper_bg">
                        <div class="swiper_top">
                            <div class="swiper_top_item1">
                                <span class="swiper_top_span1">仪表号</span>
                                <span class="swiper_top_span2">{{item.meterNo}}</span>
                            </div>
                            <div class="swiper_top_item2">
                                <span class="swiper_top_span1">仪表名</span>
                                <span class="swiper_top_span2">{{item.name}}</span>
                            </div>
                            <span class="swiper_top_span3">{{index+1}}/{{biaoList.length}}</span>
                        </div>
                        <div class="swiper_footer">
                            <span class="swiper_top_span4">{{item.merchantName}}</span>
                            <span class="swiper_top_span5">{{item.storeNo}}</span>
                        </div>

                    </div>
                </mt-swipe-item>
            </mt-swipe>
            <img @click="changeSwipeIndex(-1)" class="prevIcon"
                    src='../../assets/images/btn_coupon_last@2x.png'/>
            <img @click="changeSwipeIndex(1)" class="nextIcon"
                    src='../../assets/images/btn_coupon_next@2x.png'/>
        </div>
        <div class="yuerBg">
            <span class="yuer_span1">余额</span>
            <div class="yuer_div" >
                <span class="yuer_span2">{{syAmount}}</span>
                <span class="yuer_span3">元</span>
            </div>
             <img class="yuer_Icon" @click="getYuer()"
                    src='../../assets/images/btn_refresh@2x.png'/>
        </div>
        <div class="body">
            <div class="bodyItem">
                <div class="bodyItem_left">
                    <span class="bodyItem_span">充值金额(元)</span>
                </div>
                <div class="bodyItem_right">
                   <input class="inp_amount" type="number" maxlength="9" @input="oninput"
                   v-model="amount" placeholder="请输入金额">
                </div>
            </div>
            <div class="bodyItem1">
                <span @click="toRecharge" :class="[amount?'body_button1':'body_button2']">立即充值</span>
            </div>

        </div>
        <div class="listView">
            <div class="listItem" @click="toRecord">
                <span class="listItem_span">充值记录</span>
                <img class="listItem_icon" src="../../assets/images/icon_indicator_next.png"/>
            </div>
            <div class="listLine"></div>
             <div class="listItem" @click="toUseStatistics">
                <span class="listItem_span">能耗统计</span>
                <img class="listItem_icon" src="../../assets/images/icon_indicator_next.png"/>
            </div>
        </div>

        <!-- v-if="templateIds" -->
        <template v-if="templateIds" >
            <div class="subscribeBox" >
              <wx-open-subscribe :template="templateIds"  id="subscribe-btn">
                <script type="text/wxtag-template" slot="style">
                    <style>
                        .subscribe-btn {
                            margin-left: 16px;
                            padding-left: 10px;
                            padding-right: 10px;
                            line-height: 34px;
                            flex-direction: row;
                        }
                        .subscribe-img{
                          margin-top: 0px;
        
                          height: 25px;
                          width: 25px;
                        }
                        .subscribe-text{
                          color:#1296db;
                          font-size: 18px;
                          padding-right: 3px;
                        }
                        .subscribe-text1{
                          font-size: 18px;
                          color:#999999;
                        }
                    </style>
                </script>
                <script type="text/wxtag-template">
                    <div class="subscribe-btn" style="display:flex;align-items:center;justify-content:center;">
                      <img class='subscribe-img' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAALn0lEQVR4nO3dTU4b2RoG4O8Yk3uRbhI3Tks9C0gh0zgriLOCmBXETFoNPQhZQcgKIINrpJ5AVhCyAswKAtM4EmbWUi60kwy46hiffis4Oi0aDlXH5Z/66n2kEx+j7giXv7fOT5UdI0R0JQaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GJAJ8eNvh5Wz3tdHYk3JGNk//mXhLX5MY8aAjNm3YHS7W+hW0P6uY4x5frx8b1tobAwajUk/HLvoltAuZ+Xlya8La0JjYdBoTGYb7w/xFszJNQpGHv9veaEpNHIMyJiUNz/UrbVb6F4La5K3x8sLNXRpxBiQMUFANhCQZ+jG0TlZWfgBjzRiDMiYlButphV5hG4sCAjfqzHgQR+xnzYP57q2e7cndhuHf05iMgWpFQrFo48/z+/jKY0IAzJkdxqtRz0jVWOlakWqkgK8aU20fVuQ5s1/FffaS/Md/JiGAMeZ0jS3dVj6cnr2BPuzNQSihh8NHd7EHfy5c3Nm6i3Dki4cW0pDdE2jd3b2DAvvGp6W0MYCb+gOdr1ecVs4HTieNIhy48NTjBZ1m9L0KT22baSwdrxy7zWeUCCDRgHubLaqPSvr6FbQJhiDMgiDRglEu1BfbXdr8kYMP7zRTWPkJadeyeC4UVyzm60XYmVNMqwgsvGfmeJLLubjYUBiiBbgZ5ffcZtRtl0wZomjyfUYkGuUz++ZitYaJTRdCnb15Jf7r9CjKzAgHrjIt94TWUVXLRQArp8UlzjluhyOD1307WLf/8/WMXLUJR/2b80UHzMk/8SAXBCF4/NpdxfdCtowHBljdmzPdgoF7CxNFTtX3V8V7Zh1pTvXs1LB/zNnba+Kt+yBDAdDcgmDRn3DCge2V9/iz51pmWr+vjzflgFEv+OX07OqSK9mxdRE5DZaWjo3TPHhoL+jJgxIX1R4KYfjCG0DZ+XtYZ2Vo98ZU8Ga2G9X8h/hR2nYx+/MkaTPoBFgt2rLotBkcEfGmLVRf9lCdGXf4hqNTScoDEmfQcu9lMLxCcFYHXUwLoqC0rOyLSJ30YIZkebxysJjdHPNoOUawlFHOLbQDRatMW7+u1ifpDPu7H9ba3h3X6Abjt+ogkOYY/0r5LvoltBCTMSocZX+aLKDbvBCPu/fqGLQcila4A62KLcHU8Xp+lVbtJPi/HV+beKtfiBhOliPzE/S6DhKuQ0IplZJvlXkAntwa2a6mqWiKTfeb2Nb+Cm6iaFIcrseMWi5059avUM3sUlcb8Q1WEjM4vHKvR10cyWXASk3WrtWpCqJZW/kuCg8JLaN1/4wy689RO4CgqlV4K5V9sPxXXmztWOtPEE3mRzuahm0XIn7fbgXfLphihUtt2AMsnDHcZjXchziyFVAQkcPjfPv/jqsKSK30eLL2Shi0HIjZPTAdY5XuM6xiq46s41W9LrW0ZLI1bZvbgISOHocoRgqmosBGxZNm/T+rRyNIgYtF3C2fIeHClpsGqdWF/WnWtGxScC2T1buz6OjnkFTL/rg0Z+2e4hubDgwe7g4VpUcwOi6gdH1Gbqx5eHkEUEd6IfRYxUP62ix5ekepLATiH19vHK/LsrlJCDJFuc4KHt5GT2+C7iAmIt/1Ae1oFvY2TEf04e/43G6nPqABEyvjnBmnJMcwki7j5J4gG4smrfAv1MfkKS3VeThTb8KFutJt8L3cTJ5iEe11AcEI8gfeCihxTJVLD6c9M94DMv5LSjd6HjFhutEP2i+TqQ6IAF7/J9wRizhMbeSTrO07/apDkj/I6e76MYSfdYj7/8eOaZZG5hmPUM3HuVX1Q2aWgFfXPAcI8gGHnOr3PhQs2LfoBuL9jWb6oAkPRtqny7EkXS7FwWk+poRXp9eSW/Ey9tnHa6CjQ2Lh5h035dl0NRKGhBMr1Qfj7iSLtQ1Hze1LyyCM+E7PFTQYrAHOBPG/G9144nFUfvCIgiIxUMsOBCq59JJMCCO2hcWYUDCJL37QPPFQtSFXgxImKTb45p3/1AXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQF3oxIGEYEAd1oRcDEoYBcVAXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQF3oxIGEYEAd1oRcDEoYBcVAXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQF3oxIGEYEAd1oRcDEoYBcVAXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQF3oxIGEYEAd1oRcDEoYBcVAXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQF3oxIGEYEAd1oRcDEoYBcVAXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQF3oxIGEYEAd1oRcDEoYBcVAXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQF3oxIGEYEAd1oRcDEoYBcVAXejEgYRgQB3WhFwMShgFxUBd6MSBhGBAHdaEXAxKGAXFQFzrNbR2WPp92/0A3FhwIBqSPAXFQF/r8tHk496ftvkG3ghYLDgQD0pc0ICK2PVWcXvz48/w+nqiCutDlx98OK2fd7i66JbTYcCAYkL7kAfmmY8QsHa/c20FfDdSFHuXND3Vr7Ra6ieFA7DEg5wID8o0xCMnyvW1RwqCpcKfRWu+JrKIbxIh9fbxyvy40UEAiCMk2QrKEbuYZtEyLFuNfTrtbVqSGp8EwPVjUNj0I1Z+mvkM3GAqreXOmuNhemu/gaWbhdWRXyGL8cvbgZOX+gH+HLuXN1o618gTdQezfMMXF35fn25JRmQ1I/yy3i24JbRCfporF6keFOzCDiEbmz6dfmyiRBzKYDo7v46we30wGpL8YX0e3hDYg28b0qi30D/b8+FbQBoZ1SSYX7wYtU2Y3Wy/wzq0JZY+RtZPlhZfoZYZBy4z+yLGFLmVU1kYSg5YJ/QX5IbqUcVi4z2dl4Z6ZgGD02MDo8QxdyjorL09+XViTDDBomVButJpW5BG6lHEour2s3LWA3zUbGBA9UHQMSNrKjffbVsxTdCnjsFB/hYX6KroTLzMBubPZqvas7KJLGZelz49kJiARTrOyDwWXmelVBL9vdqR4+wONhT24NTNdzdINjJkKyHfY8q2LtXXL0SQTUGR7WHhEt8BvS8YYNBpQ0s9PhHz2JGCT4vnJysIGHmkADEgKQjYQporFh3HvcA35+7O0EJ5kDEhKknzFUF+sz0qc39b/9Q3eqjlJAKMH39sU8CCmZLbxHqNB4s2DDs70i1ed6fsjxxt0S2ixGSNvj5cXaujSgBiQlEQbBzbwTmO8CU1rpInC3sdTsVYqxkrVilQlAC7EZeqO2Ulm0CglmGZ18HAbbZyOML2aE0oFA5KipLtZQ5GhO2WzwKBRSs4vZHb30b2LNgb88om0MSAp6y+sd9EduSRbxxQPAzIEWLCP/MNdWJi/wsJ8FV1KEQMyJAFXvoOFXJmneBiQIRpFSBiO4WJAhgxbv9G0Zx0tbZ8wrVrFtGpbaGgMGg3Z+e0i3R1076KlwB5MFafrXJAPHwMyQli817F4X5PwoBwZY9Y4aoyOQaMRKzc+1HDkqwhLDU+vCYs9MKbQxFpj56p7tmh4GJAxi74QryvdOYFe7/zeq0JBmgJFKbavu9uXhosBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyIMBIfJgQIg8GBAiDwaEyOMvAVnvFAc7+3sAAAAASUVORK5CYII="/>
                      <span class='subscribe-text'>点击此处</span>
                      <span class='subscribe-text1'>订阅水电充值预警通知</span>
                      
                    </div>
                </script>
              </wx-open-subscribe>
            </div>
          </template>
    </div>
</template>

<script>
import util from "../../utils/util";
import storage from '../../utils/storage';
import ping from '../../utils/pingpay.js'
import { mapState,mapActions } from "vuex";
 import wx from 'weixin-js-sdk'
import {callSpaceUp,insertRechargeOrder,getWxTemplates ,getShareInfo} from "../../utils/api";
export default {
  components: {  },
  name: "hpRecharge",
  data() {
    return {

        qCompanyId:"", //url 带过来的有权限的认证公司ID
       timeout:'',//定时器
       biaoList:[],
       syAmount:0,
       amount:'',
       swipeIndex:0,
       selectIntelligence:'', //选中的电表
       intelligenceCode:'' , //表号
       storeNo:'', //单元号
       orderNo:'',
       templateIds:'',
       ShareInfo:"",
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
     this.getDeviceList();
     this.qCompanyId = this.$route.query.companyId
     //this.insertRechargeOrder()
     this.getWxTemplatesAction();
  },
  activated () {
    this.getShareInfo();
  },
  methods: {
        ...mapActions(['getMarketInfo','getUserInfo','getTenantInfo','getTenantInfoList','getTheme','getHolidayStyle']),
        handleChange(index){
            this.swipeIndex =index
            clearTimeout(this.timeout) //防止连续滚动触发
            this.timeout = setTimeout(() => {
                 this.swipeIndex =index
                 console.log("handleChangeIndex ===  "  + index)
                 this.intelligenceCode =this.biaoList[index].id
                 this.storeNo = this.biaoList[index].storeNo
                 this.selectIntelligence =this.biaoList[index]
                 this.getYuer();
            }, 500)
        },
        getWxTemplatesAction(){
            let params = {
                orderType:6   //6 水电充值 PAY_SDCZ 
            }
            getWxTemplates(params).then(res=>{
                if(res.res.code === 10000){
                    var list = res.body.wxMsgTemplateList
                    var list1 =[]
                    for(var i=0;i<list.length;i++){
                    list1.push(list[i].templateId)
                    }
                    this.templateIds = list1.join(',')

                    console.log('this.templateId ===  ' + this.templateIds)
                }
            })
        },
        getShareInfo(){
            var url =  window.location.href.split('#')[0]
            let params = {
                url:url
            }
            if(this.$route.query.cityId){
                params.cityId = this.$route.query.cityId
            }else if(this.common.cityId)  {
                params.cityId = this.common.cityId
            }else{
                params.marketId = this.common.marketInfo.id || ''
            }
            console.log('in getShareInfo   '+ JSON.stringify(params) );
            var that = this;
            getShareInfo(params).then(res=>{
                if(res.res.code === 10000){
                    this.ShareInfo =res.body;
                    wx.config({
                        debug: false,
                        appId: this.ShareInfo.appid, // 必填，公众号的唯一标识
                        timestamp: this.ShareInfo.timestamp, // 必填，生成签名的时间戳，精确到秒
                        nonceStr: this.ShareInfo.nonceStr, // 必填，生成签名的随机串
                        signature: this.ShareInfo.signature, // 必填，签名
                        jsApiList: ['onMenuShareAppMessage'],
                        openTagList: ['wx-open-subscribe']
                    })
                    wx.error(function(res){
                    // util.showToast("错误信息== error   " + res.errMsg,6000);
                    // 暂时解决不了 比较慢的iOS手机微信版本 获取的URL问题 所以config失败 使用当前url 再config 一次
                        console.log('in error  '+ JSON.stringify(res) );
                        var errMsg =  res.errMsg
                        if(errMsg.indexOf('config') > -1 ){
                            that.errorBackconfig();
                        }
                    });

                    wx.ready(()=>{
                        console.log("in wx.ready")
                    })
            
                }
            })
        },

    //config 失败后用当前url重新config
        errorBackconfig(){
            var url =  window.location.href.split('#')[0]
            let params = {
                url:url
            }
            if(this.$route.query.cityId){
                params.cityId = this.$route.query.cityId
            }else if(this.common.cityId)  {
                params.cityId = this.common.cityId
            }else{
                params.marketId = this.common.marketInfo.id || ''
            }
            console.log('in errorBackconfig   '+ JSON.stringify(params) );
    
            getShareInfo(params).then(res=>{
                var configMap={
                    debug: false,
                    appId: res.body.appid , // 必填，公众号的唯一标识
                    timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
                    nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
                    signature: res.body.signature, // 必填，签名
                    jsApiList: ['onMenuShareAppMessage'],
                    openTagList: ['wx-open-subscribe']
                }
                wx.config(configMap)
                wx.error(function(res){
                    // util.showToast("错误信息== error   " + res.errMsg,6000);
                    console.log('in error  '+ JSON.stringify(res) );
                });
                wx.ready(()=>{
                    console.log("in errorBackconfig wx.ready")
                })
            })

        },

        changeSwipeIndex(index){
            // console.log("changeSwipeIndex ===  "  + this.$refs.swipe.index)
            // var swipeIndex = this.$refs.swipe.index; //轮播当前索引
            if (index==1) {
                //if(this.swipeIndex<this.biaoList.length){
                    this.$refs.swipe.next(); // 转到下一张轮播图
                //}
                // this.swipeIndex=this.$refs.swipe.index
            } else if (index==-1) {
               // if(this.swipeIndex>0){
                    this.$refs.swipe.prev(); // 转到前一张轮播图
                //}
                //  this.swipeIndex=this.$refs.swipe.index
            }
            console.log("hpRecharge    === " +  this.swipeIndex)
        },
        //huo
        getDeviceList() {
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                page:1,
                pageSize:100,
                spaceName:'',
                platform: "RST",
                merchantId: this.qCompanyId ?this.qCompanyId:(this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : ''), // space up 的 租客ID 44,//
                url: "/property/rstRepair/queryDeviceMonitorPage"
            }
            callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                   var list =res.body.data.list
                    for(var i=0;i<list.length;i++){
                        var item =list[i];
                        var pitem  =item.prpDeviceSpaceRelBeans
                        if(pitem && pitem.length>0){
                            item.storeNo = pitem[0].subProjectName +'-'+pitem[0].buildName+"-"+pitem[0].spaceName
                        }
                    }
                    this.biaoList =list;
                    if(list.length>0){
                        this.intelligenceCode =list[0].id
                        this.storeNo = list[0].storeNo
                        this.selectIntelligence =this.biaoList[0]
                        this.getYuer()
                    }else{
                        util.showToast("没有相关电表数据")
                    }
                }
            });
        },
        //获取表余额
        getYuer(){
             var params = {
                 deviceId:this.intelligenceCode,
                 marketId: this.common.marketInfo.id,
                 companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                 merchantId:   this.qCompanyId ?this.qCompanyId:(this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : ''), // space up 的 租客ID 44,//
                 url:"/property/rstRepair/loadPrpDeviceById"
             }
              callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                    var obj =res.body.data
                    this.syAmount = obj.balance ||0
                }
            });
        },
        //生成订单
        toRecharge(){
            if(!this.amount){
                return
            }
            if(!this.intelligenceCode){
                util.showToast("没有可以充值的电表")
                return
            }
            var that=this
            var msg ="确定要为表"+that.selectIntelligence.name +"充值"+that.amount+"元吗?"
            util.showModal('',msg,true,'确定',()=>{
                that.insertRechargeOrder();
            })
            // var params = {
            //     userId: this.common.userId,
            //     marketId: this.common.marketInfo.id,
            //     companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
            //     deviceId:this.intelligenceCode, //1731
            //     platform: "RST",
            //     merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
            //     url: "/property/rstRepair/checkMeterCanRemoteCharge"
            // }
            // var that=this
            // callSpaceUp(params).then(res => { //检查是否可以充值
            //     if (res.res.code == 10000) {
            //          var msg ="确定要为表"+that.selectIntelligence.name +"充值"+that.amount+"元吗?"
            //             util.showModal('',msg,true,'确定',()=>{
            //                 that.insertRechargeOrder();
            //         })
            //     }else{
            //         util.showToast(res.res.msg)
            //     }
            // });


        },

        insertRechargeOrder(){
            var companyId =  this.qCompanyId ?this.qCompanyId:(this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '')
            let params = {
                userId: this.common.userId,
                userName: this.common.userTenantInfo.userName ||this.common.userInfo.userName ||this.common.userInfo.name ,
                cityId:  String(this.common.marketInfo.cityId) , //'20',//
                marketId: this.common.marketInfo.id,
                companyId: String( companyId),// '44',
                phone:this.common.userTenantInfo.phone ,
                rechargeType: 2, //2是电费,1是水费
                rechargeAmount: parseFloat(this.amount),
                // unitPrice: parseFloat(this.data.unitPrice),
                // kwh: parseFloat(kwh), //this.data.dushu
                storeNo: this.storeNo,
                intelligenceCode: String(this.intelligenceCode) ,
            };
            // console.log("params == "  +JSON.stringify(params))
            insertRechargeOrder(params).then(res => {
                if (res.res.code == 10000) {
                    this.orderNo=res.body.orderNo;
                    this.pingPay();
                }
            });

        },

        oninput(e) {
            // 通过正则过滤小数点后两位
            e.target.value = e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null
            console.log('e',e.target.value)
            this.amount = e.target.value
        },
        toRecord(){
            // id=${item.id}`
             this.$router.push('/rechargeRecord');
        },
        toUseStatistics(){
             this.$router.push('/hpuseStatistics');
        },


        pingPay() {
            let self = this;
            let params = {
                orderNo: this.orderNo,
                repairNo: '', // "报修单号",
                bussinessType: "8", //水电充值
                payType: "", //
                feeCode: "",
                channel: 'wx_pub' // 渠道名
            };
            ping(params,
                '',
                res => {
                    self.paySuccess();
                }, () => {
                    util.showToast("支付失败");
                }, () => {
                    util.showToast("支付取消");
            })
        },
        paySuccess(){
            console.log("支付成功") //刷新余额数据
            this.getYuer();

        },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
  background: #F3F4F6;
  flex-direction: column;
}
.topBg{
    flex-direction: column;
    position: relative;
    width: 750px;
    height: 322px;
    background: #FFFFFF;
}

//轮播图
.swiper_bg{
    margin-top: 28px;
    margin-left: 28px;
    margin-right: 28px;
    width: 694px;
    height: 266px;
    background: linear-gradient(270deg, #FFBE00 0%, #FFA100 100%);
    box-shadow: 0px 8px 24px 0px #FFEAC8;
    border-radius: 12px;
    flex-direction: column;
}
.swiper_top{
    width: 694px;
    display: flex;
    height: 136px;
    flex-direction: column;
    position: relative;
}
.swiper_top_item1{
    width: 694px;
    display: flex;
    height: 40px;
    margin-top: 28px;
    flex-direction: row;
}
.swiper_top_item2{
    width: 694px;
    height: 40px;
    display: flex;
    margin-top: 8px;
    flex-direction: row;
}
.swiper_top_span1{
    margin-left: 28px;
    width: 100px;
    display: flex;
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span2{
    width: 452px;
    height: 40px;
    display: flex;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span3{
    position: absolute;
    right: 28px;
    top:28px;
    height: 32px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 32px;
}
.swiper_footer{
    width: 694px;
    height: 130px;
    background: rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
}
.swiper_top_span4{
     width: 638px;
    margin-top: 20px;
    margin-left: 28px;
    height: 34px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 34px;
}
.swiper_top_span5{
     margin-top: 8px;
    margin-left: 28px;
    width: 638px;
    height: 40px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
// 箭头。
.prevIcon{
    position: absolute;
    left: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;

}
.nextIcon{
    position: absolute;
    right: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;
}

// yuerBg
.yuerBg{
    margin-top: 14px;
    width: 750px;
    height: 196px;
    display: flex;
    position: relative;
    background: #FFFFFF;
    flex-direction: column;
}
.yuer_span1{
    margin-top: 28px;
    width: 750px;
    text-align: center;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
}
.yuer_div{
    margin-top: 4px;
    width: 750px;
    flex-direction: row;
    width: 750px;
    display: flex;
    justify-content: center;

}
.yuer_span2{
    height: 84px;
    font-size: 60px;
    font-weight: 400;
    color: #333333;
    line-height: 84px;
}
.yuer_span3{
    margin-left: 8px;
    margin-top: 28px;
    height: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 44px;
}
.yuer_Icon{
    position: absolute;
    width: 44px;
    height: 44px;
    top: 28px;
    right: 28px;
}

//body
.body{
    width: 750px;
    height: 256px;
    background: #FFFFFF;
    flex-direction: column;
    display: flex;
}
.bodyItem{
    width: 750px;
    height: 100px;
    background: #FFFFFF;
    display: flex;
    flex-direction: row;
}
.bodyItem_left{
    width: 258px;
    height: 100px;
    flex-direction: row;
    display: flex;
}
.bodyItem_span{
    margin-left: 40px;
    height: 100px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 100px;
}
.bodyItem_right{
    width: 492px;
    height: 100px;
    flex-direction: row;
    display: flex;
    border-bottom: 2px solid #eaeaea;
}
.inp_amount{
    width: 470px;
    height: 100px;
    font-size: 32px;
    font-weight: 400;
    color: #666666;
    line-height: 100px;
}
.bodyItem1{
    width: 750px;
    height: 156px;
    flex-direction: column;
    display: flex;
}
.body_button1{
    margin-top: 40px;
    margin-left: 28px;
    width: 694px;
    height: 88px;
    background: #0087ff;
    border-radius: 4px;
    text-align: center;
    font-size: 34px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 88px;
}

.body_button2{
    margin-top: 40px;
    margin-left: 28px;
    width: 694px;
    height: 88px;
    background: #DADADA;
    border-radius: 4px;
    text-align: center;
    font-size: 34px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 88px;
}
.listView{
    flex-direction: column;
    margin-top: 14px;
    width: 750px;
}
.listItem{
    flex-direction: row;
    width: 750px;
    display: flex;
    height: 100px;
    background: #FFFFFF;
    justify-content: space-between;
    align-items: center;
}
.listLine{
    display: flex;
    margin-left: 28px;
    width: 722px;
    height: 2px;
    background: #EAEAEA;
}
.listItem_span{
    height: 44px;
    margin-left: 28px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height:44px;
}
.listItem_icon{
    margin-right: 28px;
    width: 32px;
    height: 32px;
    // margin-top: 28px;
    // background-color: seagreen;
}


.subscribeBox{
    margin-top: 40px;
    width: 750px;
    height: 100px;
    display: flex;
  }


</style>